import styled from 'styled-components';

import { createGradientOrSolid } from 'utils';
import { SubRollingOfferUiProps } from '../../../shared/types';
import { subOfferHeight } from 'templates/RollingOffer/shared/utils';

export interface StyledSubRollingOfferProps extends SubRollingOfferUiProps {
  clickable?: boolean;
}

export const StyledSubRollingOffer = styled.div<StyledSubRollingOfferProps>`
  width: 100%;
  height: ${subOfferHeight}px;
  background: ${({ backgroundColor, backgroundImage }) =>
    backgroundImage
      ? `url(${backgroundImage}) no-repeat center center`
      : backgroundColor && createGradientOrSolid(backgroundColor)};
  background-size: cover;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
  position: relative;
  direction: ltr;

  .product-image-container {
    position: relative;
    display: flex;
    flex-direction: row;
  }
`;
